import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate, translate} from "react-i18nify";

import * as componentTypes from "../../../../constants/componentTypes";
import * as settings from "../../../../constants/settings";
import * as config from "../../../../constants/config";
import * as navigationActions from "../../../../actions/navigationActions";
import * as rccActions from "../../../../actions/rccActions";
import * as formatHelper from "../../../../helpers/formatHelper";
import * as batchActions from "../../../../actions/batchActions";
import * as batchStatuses from "../../../../constants/batchStatuses";
import * as modelHelper from "../../../../helpers/modelHelper";

import Table from "../../../global/generic/Table";
import CloseButton from "../../../global/generic/CloseButton";
import Modal from "../../../global/generic/Modal";

class CanisterRefillDetailHistoryModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            tab: "history",
            offset: 0,
            listLength: 0
        };
    }

    componentDidMount = () => {
        if (this.props.activeCanister !== null) {
            this.props.dispatchGetCanisterRefillHistoryAction(
                this.props.activeCanister.id,
                this.state.offset,
                config.MAX_COLORANT_LIMIT
            );
        }
        if (
            this.props.ufiCodeLogic !== settings.UFI_CODE_LOGIC_DISABLED &&
            this.props.ufiCodeLogic !== settings.UFI_CODE_LOGIC_DB_VALUES
        ) {
            this.props.dispatchGetCanisterUfiCodes(this.props.activeCanister.id);
        }

        if (this.props.colorantBatchNumberLogic !== settings.COLORANT_BATCH_NUMBER_LOGIC_DISABLED) {
            this.props.dispatchGetBatchesByColorantAction(this.props.activeCanister.colorant.id);
        }
    };

    handleScroll = (e) => {
        if (this.props.activeCanister !== null && this.state.tab === "history") {
            const isBottom = Math.ceil(e.target.scrollHeight) === Math.ceil(e.target.scrollTop + e.target.clientHeight);
            if (
                isBottom &&
                this.state.offset <= this.props.refillHistory.length &&
                this.getListLength() < this.props.refillHistory.length
            ) {
                this.props.dispatchGetCanisterRefillHistoryWithOffsetAction(
                    this.props.activeCanister.id,
                    this.state.offset + config.MAX_COLORANT_LIMIT,
                    config.MAX_COLORANT_LIMIT
                );
                this.setState({
                    offset: this.state.offset + config.MAX_COLORANT_LIMIT,
                    listLength: this.props.refillHistory.length
                });
            }
        }
    };

    handleCloseModalClick = () => {
        this.props.dispatchCloseModalAction();
    };

    onTabClick = (event) => {
        this.setState({
            tab: event.currentTarget.dataset.tab
        });
    };

    getListLength = () => {
        return this.state.listLength;
    };

    getRefillHistoryRows = () => {
        let records = [];

        for (let record of this.props.refillHistory) {
            records.push(
                <div className="general-table-row col-12" key={record.id}>
                    <div className="col-3">{formatHelper.formatDateTimeUtc(record.date)}</div>
                    <div className="col-3">
                        {formatHelper.formatDecimal(record.amount)}&nbsp;{this.props.rccUnit}
                    </div>
                    {this.props.ufiCodeLogic !== settings.UFI_CODE_LOGIC_DISABLED &&
                        this.props.ufiCodeLogic !== settings.UFI_CODE_LOGIC_DB_VALUES && (
                            <div className="col-3">{record.ufi}</div>
                        )}
                    {this.props.colorantBatchNumberLogic !== settings.COLORANT_BATCH_NUMBER_LOGIC_DISABLED && (
                        <div className="col-3">{record.batch}</div>
                    )}
                </div>
            );
        }

        return records;
    };

    getTableHeader = () => {
        const tableHeaders = [
            modelHelper.buildTableCell(<Translate value="general.fillingDate" />),
            modelHelper.buildTableCell(<Translate value="general.amount" />)
        ];

        if (
            this.props.ufiCodeLogic !== settings.UFI_CODE_LOGIC_DISABLED &&
            this.props.ufiCodeLogic !== settings.UFI_CODE_LOGIC_DB_VALUES
        ) {
            tableHeaders.push(modelHelper.buildTableCell(<Translate value="general.ufiCode" />));
        }

        if (this.props.colorantBatchNumberLogic !== settings.COLORANT_BATCH_NUMBER_LOGIC_DISABLED) {
            tableHeaders.push(modelHelper.buildTableCell(<Translate value="general.batchNumber" />));
        }

        return modelHelper.buildTableRow(tableHeaders);
    };

    getTableColumns = () => {
        return [
            modelHelper.buildTableColumn("col-3"),
            modelHelper.buildTableColumn("col-2"),
            modelHelper.buildTableColumn("col-4"),
            modelHelper.buildTableColumn("col-3")
        ];
    };

    getTableRows = () => {
        return this.props.refillHistory.map((record) => {
            const rowData = [
                modelHelper.buildTableCell(formatHelper.formatDateTimeUtc(record.date)),
                modelHelper.buildTableCell(
                    <React.Fragment>
                        {formatHelper.formatDecimal(record.amount)}&nbsp;{this.props.rccUnit}
                    </React.Fragment>
                )
            ];

            if (
                this.props.ufiCodeLogic !== settings.UFI_CODE_LOGIC_DISABLED &&
                this.props.ufiCodeLogic !== settings.UFI_CODE_LOGIC_DB_VALUES
            ) {
                rowData.push(modelHelper.buildTableCell(record.ufi));
            }

            if (this.props.colorantBatchNumberLogic !== settings.COLORANT_BATCH_NUMBER_LOGIC_DISABLED) {
                rowData.push(modelHelper.buildTableCell(record.batch));
            }
            return modelHelper.buildTableRow(rowData, "", record.id);
        });
    };

    getHistoryOfRefillContent = () => {
        return (
            <Table
                className="flex-child"
                tableHeader={this.getTableHeader()}
                tableRows={this.getTableRows()}
                tableColumns={this.getTableColumns()}
                onScroll={this.handleScroll}
            />
        );
    };

    getVerticalProgressLevels = (percentages, totalLevel) => {
        let percent = 0;
        let bottom = 0;

        return percentages.map((percentage, i) => {
            percent += formatHelper.convertDecimalToPercent(percentage);
            bottom = totalLevel * percent;
            return (
                <div
                    key={i}
                    className="fill-level"
                    style={{
                        bottom: bottom.toString() + "%"
                    }}
                />
            );
        });
    };

    getUfiCodeRefills = (ufiCodeFromRefill) => {
        if (!ufiCodeFromRefill && this.props.ufiCodeList.length === 0) {
            return "";
        }

        return this.getVerticalProgressLevels(
            this.props.ufiCodeList.map((ufi) => ufi.contentPercent),
            this.props.activeCanister.currentLevelPercent
        );
    };

    getBatchNumberRefills = () => {
        return this.getVerticalProgressLevels(
            this.props.batchNumbersList.map((batchNumber) => batchNumber.contentPercent),
            this.props.activeCanister.currentLevelPercent
        );
    };

    calculateMiddle = (bottom, contentPercent) => {
        return (
            this.props.activeCanister.currentLevelPercent *
            (bottom + formatHelper.convertDecimalToPercent(contentPercent) / 2)
        );
    };

    getVerticalProgressNote = (percentage, bottom, key, notes) => {
        return (
            <div
                key={key}
                className="note"
                style={{
                    bottom: this.calculateMiddle(bottom, percentage) + "%"
                }}
            >
                {notes}
            </div>
        );
    };

    getUfiCodes = (ufiCodeFromRefill) => {
        let canisterLevel = this.props.activeCanister.currentLevelPercent;

        if (!ufiCodeFromRefill && this.props.ufiCodeList.length === 0) {
            return this.getVerticalProgressNote(
                canisterLevel * 50,
                0,
                0,
                <React.Fragment>
                    <div>
                        {formatHelper.formatDecimal(this.props.activeCanister.currentLevel)}&nbsp;
                        {this.props.rccUnit}
                    </div>
                    <div>100 %</div>
                    <div>{this.props.activeCanister.ufi}</div>
                </React.Fragment>
            );
        }

        let bottom = 0;

        return this.props.ufiCodeList.map((ufi, i) => {
            const oldBottom = bottom;
            bottom += formatHelper.convertDecimalToPercent(ufi.contentPercent);

            return this.getVerticalProgressNote(
                ufi.contentPercent,
                oldBottom,
                i,
                <React.Fragment>
                    <div>
                        {formatHelper.formatDecimal(this.props.activeCanister.currentLevel * ufi.contentPercent)}
                        &nbsp;
                        {this.props.rccUnit}
                    </div>
                    <div>{formatHelper.formatDecimal(formatHelper.convertDecimalToPercent(ufi.contentPercent))} %</div>
                    <div>{this.getStatus(ufi.ufiCode)}</div>
                </React.Fragment>
            );
        });
    };

    getStatus = (batchNumber) => {
        const statusId = this.props.colorantBatchNumbers.find((batch) => batch.batchNumber === batchNumber)?.statusId;

        switch (statusId) {
            case batchStatuses.BATCH_STATUS_WARNING:
                return (
                    <span style={{color: "orange"}}>
                        <span className="glyphicon glyphicon-exclamation-sign" />
                        &nbsp;
                        <Translate value="colorantBatchNumberSettings.possibleDamagedBatchOfColorant" />
                    </span>
                );
            case batchStatuses.BATCH_STATUS_INVALID:
                return (
                    <span style={{color: "red"}}>
                        <span className="glyphicon glyphicon-remove-sign" />
                        &nbsp;
                        <Translate value="colorantBatchNumberSettings.defectiveBatchOfColorant" />
                    </span>
                );
            default:
                return "";
        }
    };

    getBatchNumbers = () => {
        let bottom = 0;

        return this.props.batchNumbersList.map((batchNumber, i) => {
            const oldBottom = bottom;
            bottom += formatHelper.convertDecimalToPercent(batchNumber.contentPercent);

            return this.getVerticalProgressNote(
                batchNumber.contentPercent,
                oldBottom,
                i,
                <React.Fragment>
                    <div>
                        {formatHelper.formatDecimal(
                            this.props.activeCanister.currentLevel * batchNumber.contentPercent
                        )}
                        &nbsp;
                        {this.props.rccUnit}
                    </div>
                    <div>
                        {formatHelper.formatDecimal(formatHelper.convertDecimalToPercent(batchNumber.contentPercent))} %
                    </div>
                    <div>
                        {batchNumber.batchNumber}
                        &nbsp;{this.getStatus(batchNumber.batchNumber)}
                    </div>
                </React.Fragment>
            );
        });
    };

    isUfiCodeFromRefill = () => {
        if (this.props.activeCanister.ufi === null) {
            return true;
        }

        for (let ufi of this.props.ufiCodeList) {
            if (ufi.ufiCode === this.props.activeCanister.ufi) {
                return true;
            }
        }

        return false;
    };

    getUfiCodeStatusMessage = (ufiCodeFromRefill) => {
        if (ufiCodeFromRefill) {
            return "";
        }

        return (
            <div className="dialog-messages messages-warning">
                <Translate value="ufiCodeModal.userSetUfiCode" />{" "}
                <span className="color-primary">{this.props.activeCanister.ufi}</span>
            </div>
        );
    };

    getUfiCodeStatusContent = () => {
        let ufiCodeFromRefill = this.isUfiCodeFromRefill();
        let canisterLevel = this.props.activeCanister.currentLevelPercent * 100;

        return (
            <React.Fragment>
                {this.getUfiCodeStatusMessage(ufiCodeFromRefill)}
                <div className="fill-flex-space vertical-progress">
                    <div className="progress-bar">
                        <div
                            className="fill"
                            style={{
                                backgroundColor: this.props.activeCanister.colorant.rgb,
                                height: canisterLevel.toString() + "%"
                            }}
                        />
                        {this.getUfiCodeRefills(ufiCodeFromRefill)}
                    </div>
                    <div className="notes">{this.getUfiCodes(ufiCodeFromRefill)}</div>
                </div>
            </React.Fragment>
        );
    };

    getBatchNumbersContent = () => {
        let canisterLevel = this.props.activeCanister.currentLevelPercent * 100;

        return (
            <React.Fragment>
                <div className="fill-flex-space vertical-progress">
                    <div className="progress-bar">
                        <div
                            className="fill"
                            style={{
                                backgroundColor: this.props.activeCanister.colorant.rgb,
                                height: canisterLevel.toString() + "%"
                            }}
                        />
                        {this.getBatchNumberRefills()}
                    </div>
                    <div className="notes">{this.getBatchNumbers()}</div>
                </div>
            </React.Fragment>
        );
    };

    getActiveTab = () => {
        switch (this.state.tab) {
            case "history":
                return this.getHistoryOfRefillContent();
            case "ufi":
                return this.getUfiCodeStatusContent();
            case "batch":
                return this.getBatchNumbersContent();
            default:
                return "";
        }
    };

    getTabClassName = (tab) => {
        if (tab === this.state.tab) {
            return "general-tab active";
        }

        return "general-tab";
    };

    getTabList = () => {
        return (
            <div className="general-tab-list">
                <div className={this.getTabClassName("history")} data-tab="history" onClick={this.onTabClick}>
                    <Translate value="navigation.menu.colorantRefillHistory" />
                </div>
                {this.props.colorantBatchNumberLogic !== settings.COLORANT_BATCH_NUMBER_LOGIC_DISABLED && (
                    <div className={this.getTabClassName("batch")} data-tab="batch" onClick={this.onTabClick}>
                        <Translate value="canisterRefillHistoryModal.batchNumberOfFilling" />
                    </div>
                )}
                {this.props.ufiCodeLogic !== settings.UFI_CODE_LOGIC_DISABLED &&
                    this.props.ufiCodeLogic !== settings.UFI_CODE_LOGIC_DB_VALUES && (
                        <div className={this.getTabClassName("ufi")} data-tab="ufi" onClick={this.onTabClick}>
                            <Translate value="canisterRefillHistoryModal.ufiCodeStatus" />
                        </div>
                    )}
            </div>
        );
    };

    canDisplayContent = () => {
        return this.props.activeCanister !== null && this.props.activeCanister.colorant !== null;
    };

    getContent = () => {
        if (this.canDisplayContent()) {
            return modelHelper.buildModalSection(
                <div className="flex-child fill-flex-space general-tabs primary-tabs">
                    {this.getTabList()}
                    <div className="general-tab-content flex flex-column slim-scroll">{this.getActiveTab()}</div>
                </div>
            );
        }
        return modelHelper.buildModalSection(translate("general.notAvailable"), "flex-align-center");
    };

    getFooter = () => {
        if (this.canDisplayContent()) {
            return modelHelper.buildModalSection(<CloseButton onClick={this.handleCloseModalClick} />);
        }
        return undefined;
    };

    render() {
        return (
            <Modal
                modalId={this.props.id}
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(
                    translate("ufiCodeModal.detailedInfoForColorant", {
                        colorantName: this.props.activeCanister?.colorant?.name ?? ""
                    })
                )}
                content={this.getContent()}
                footer={this.getFooter()}
                styles={{minWidth: "60%", minHeight: "60%"}}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        activeCanister: store.rcc.activeCanister,
        ufiCodeList: store.machine.ufiCodeList,
        batchNumbersList: store.machine.allBatchNumbersList[store.rcc.activeCanister?.id] ?? [],
        refillHistory: store.machine.refillHistory,
        rccUnit:
            store.rcc.machineConfigurationList === null ? settings.UNIT_ML : store.rcc.machineConfigurationList.unit,
        ufiCodeLogic: store.settings.ufiCodeLogic,
        colorantBatchNumberLogic: store.settings.colorantBatchNumberLogic,
        colorantBatchNumbers: store.machine.batchesByColorant
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.COLORANT_UFI_CODES_MODAL));
        },
        dispatchGetCanisterRefillHistoryAction: (index, offset, rowCount) => {
            dispatch(rccActions.getCanisterRefillHistory(index, offset, rowCount));
        },
        dispatchGetCanisterRefillHistoryWithOffsetAction: (index, offset, rowCount) => {
            dispatch(rccActions.getMachineRefillHistoryWithOffset(index, offset, rowCount));
        },
        dispatchGetCanisterUfiCodes: (index) => {
            dispatch(rccActions.getCanisterUfiCodes(index));
        },
        dispatchGetBatchesByColorantAction: (colorantId) => {
            dispatch(batchActions.getBatchesByColorant(colorantId));
        }
    };
};

export default CanisterRefillDetailHistoryModal = connect(
    mapStoreToProps,
    mapDispatchToProps
)(CanisterRefillDetailHistoryModal);
